import React, { useState, useEffect } from "react";
import moment from "moment";
import Select from "../wms/select";
import { getBranchList, getWoodChipToProduce } from "../../services/wms";
import Reporttable from "./producelist";
import numberWithCommas from '../common/number';
const Reportproduce = ({ startDate, endDate, disabled }) => {
  const [branchlist, setbranchlist] = useState([]);
  const [reportlist, setreportlist] = useState([]);
  const [totallist, settotallist] = useState([]);
  const [branchId, setbranchId] = useState(0);
  
  const [data, setdate] = useState({});

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getBranchList();
      if (result.status === "success") {
        setbranchlist(result.data.list);
      }
    };
    loadData();
  }, []);

  
  useEffect(() => {
    
    disabled(true);
    const loadData = async () => {
      const { data: result } = await getWoodChipToProduce(
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        branchId
      );
      
      if (result.status === "success") {
        disabled(false);
        setreportlist(result.data.list);
        settotallist(result.data.total)
      }
      
    };
    loadData();
  }, [startDate, endDate, branchId]);

  // useEffect(() => {
  //   if (reportlist && reportlist.length > 1) {
  //     setdate({

  //     });

  //   }
  // }, [reportlist]);

  const handleBranchChange = (event) => {
    setbranchId(event.currentTarget.value);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 col-md-12   mt-2 mb-2 ">
            <Select
              data={branchlist}
              label="โรงชิพ"
              value={branchId}
              textProperty="name"
              valueProperty="_id"
              onChange={handleBranchChange}
            />
          </div>
          <div className="col-lg-10 col-md-12">
            <div className="col-auto mx-1 mb-3">
              <div className="card">
                <div className="card-body p-3">
                 { totallist && totallist.length > 0 && <div className="row justify-content-center
           align-items-center">
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-primary">
                        {numberWithCommas(totallist[0].logrecive)}
                        </span>
                      </h3>
                      ไม้ท่อนรับเข้า
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].logtoproduce)}
                        </span>
                      </h3>
                      ไม้ท่อนผลิต
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].directproduce)}
                        </span>
                      </h3>
                      Direct เข้าผลิต
                    </div>

                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].stockproduce)}
                        </span>
                      </h3>
                      Stock เข้าผลิต
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].productperday)}
                        </span>
                      </h3>
                      ผลผลิต ตัน/วัน
                    </div>
                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].chipout)}
                        </span>
                      </h3>
                      ไมสับส่งออก
                    </div>

                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].barkout)}
                        </span>
                      </h3>
                      เปลือกขายออก
                    </div>

                    <div className="col-auto mx-2 text-center">
                      <h3>
                        <span className="badge rounded-pill bg-success">
                        {numberWithCommas(totallist[0].logout)}
                        </span>
                      </h3>
                      ไม้ท่อนย้ายออก
                    </div>
                  </div> }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mx-1 mb-3">
            <div className="card">
              <div className="card-body p-3">
               { totallist && totallist.length > 0 && <div className="row justify-content-center
           align-items-center">
                  <div className="col-auto  text-center">
                    <h4 className="d-inline"> Stock </h4>
                  </div>

                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-warning text-dark">
                      {numberWithCommas(totallist[0].logstock)}
                      </span>
                    </h3>
                    Stock ไม้ท่อน
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-warning text-dark">
                      {numberWithCommas(totallist[0].chipstock)}
                      </span>
                    </h3>
                    Stock ไม้สับ
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-warning text-dark">
                      {numberWithCommas(totallist[0].finestock)}
                      </span>
                    </h3>
                    Stock เปลือก
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-warning text-dark">
                      {numberWithCommas(totallist[0].barkstock)}
                      </span>
                    </h3>
                    Stock เปลือกหยาบ
                  </div>
                  <div className="col-auto  text-center">
                    <h3>
                      <span className="badge rounded-pill bg-warning text-dark">
                      {numberWithCommas(totallist[0].undersizestock)}
                      </span>
                    </h3>
                    Stock Undersize
                  </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Reporttable list={reportlist} />
    </>
  );
};

export default Reportproduce;
